export default [
  {
    component: () => import("pages/StreemCompany.vue"),
    meta: {
      title: "Streem Company",
    },
    name: "streem-company",
    path: "/streem-company",
  },
];
